module.exports = __webpack_public_path__ + "static/assets/6a8cb419123dfa9fe427b191f7b561ad.png";